// extracted by mini-css-extract-plugin
module.exports = {"cardsAuthForm":"step1_cardsAuthForm__70ALi"};